import { createContext, useContext, useEffect, useState } from "react"
import { requestJson, setAuthToken, clearAuthToken } from "../../../shared/lib/httpClient"

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [token, setToken] = useState(null)
    const [initialising, setInitialising] = useState(true)

    useEffect(() => {
        try {
            const stored = localStorage.getItem("sgrhome_admin_auth")
            if (stored) {
                const parsed = JSON.parse(stored)
                if (parsed.token) {
                    setToken(parsed.token)
                    setUser(parsed.user || null)
                    setAuthToken(parsed.token)
                }
            }
        } catch (e) {
            console.error("Failed to restore admin auth", e)
            localStorage.removeItem("sgrhome_admin_auth")
            clearAuthToken()
        } finally {
            setInitialising(false)
        }
    }, [])

    const login = async (email, password) => {
        const data = await requestJson("/api/admin/auth/login", {
            method: "POST",
            body: { email, password },
        })

        setToken(data.token)
        setUser(data.user)
        setAuthToken(data.token)
        localStorage.setItem(
            "sgrhome_admin_auth",
            JSON.stringify({ token: data.token, user: data.user })
        )
    }

    const logout = () => {
        setToken(null)
        setUser(null)
        clearAuthToken()
        localStorage.removeItem("sgrhome_admin_auth")
    }

    return (
        <AuthContext.Provider
            value={{
                user,
                token,
                isAuthenticated: !!token,
                initialising,
                login,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    const ctx = useContext(AuthContext)
    if (!ctx) throw new Error("useAuth must be used within AuthProvider")
    return ctx
}
